"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetDtoken = void 0;

var XalInternalError_1 = require("../../errors/XalInternalError");

var XalInternalErrorType_1 = require("../../errors/XalInternalErrorType");

var ITelemetryClient_1 = require("../../ITelemetryClient");

var Utils_1 = require("../../Utils");

var XboxToken_1 = require("../../XboxToken");

var OperationBase_1 = require("../OperationBase");

var RefreshDtoken_1 = require("../xboxToken/RefreshDtoken");

var GetDtoken =
/** @class */
function (_super) {
  __extends(GetDtoken, _super);

  function GetDtoken(telemetryClient, tokenStackComponents, httpClient, forceRefresh) {
    var _this = _super.call(this, telemetryClient) || this;

    _this.tokenStackComponents = tokenStackComponents;
    _this.httpClient = httpClient;
    _this.forceRefresh = forceRefresh;
    _this.resettingDeviceIdentity = false;
    return _this;
  }

  GetDtoken.prototype.run = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.dtoken = this.tokenStackComponents.xboxCache.getToken(XboxToken_1.IdentityType.Dtoken, this.tokenStackComponents.config.xboxLiveRelyingParty,
            /*subRelyingParty:*/
            "", "JWT" // Dtokens are always JWT tokens
            );
            Utils_1.assert(!!this.dtoken);
            if (!(this.forceRefresh || !this.dtoken.isValid)) return [3
            /*break*/
            , 2];
            return [4
            /*yield*/
            , this.refreshDtoken()];

          case 1:
            _a.sent();

            return [3
            /*break*/
            , 3];

          case 2:
            this.succeed(this.dtoken);
            return [2
            /*return*/
            ];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetDtoken.prototype.refreshDtoken = function () {
    return __awaiter(this, void 0, void 0, function () {
      var operation, _a, error_1, xalError;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            operation = new RefreshDtoken_1.RefreshDtoken(this.telemetryClient, this.tokenStackComponents, this.httpClient, this.dtoken);
            operation.execute();
            _b.label = 1;

          case 1:
            _b.trys.push([1, 3,, 7]);

            _a = this;
            return [4
            /*yield*/
            , operation.completionPromise];

          case 2:
            _a.dtoken = _b.sent();
            this.succeed(this.dtoken);
            return [2
            /*return*/
            ];

          case 3:
            error_1 = _b.sent();
            xalError = error_1;
            if (!(xalError && xalError.errorType && xalError.errorType === XalInternalErrorType_1.XalInternalErrorType.BadDeviceIdentity)) return [3
            /*break*/
            , 5];
            return [4
            /*yield*/
            , this.resetDeviceIdentityAndRestart()];

          case 4:
            _b.sent();

            return [2
            /*return*/
            ];

          case 5:
            if (xalError) {
              this.fail(xalError);
              return [2
              /*return*/
              ];
            } else {
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Unknown error occurred while refreshing Dtoken"));
              return [2
              /*return*/
              ];
            }

            _b.label = 6;

          case 6:
            return [3
            /*break*/
            , 7];

          case 7:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  GetDtoken.prototype.resetDeviceIdentityAndRestart = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            this.telemetryClient.instrumentAppError(ITelemetryClient_1.Area.GetDtoken, "Invalid device identity error received", this.resettingDeviceIdentity ? ITelemetryClient_1.ErrorLevel.Error : ITelemetryClient_1.ErrorLevel.Warning, XalInternalErrorType_1.XalInternalErrorType.BadDeviceIdentity);

            if (this.resettingDeviceIdentity) {
              Utils_1.xalTrace(Utils_1.TraceLevel.Error, "Dtoken operation received bad device identity errors twice in a row. Failing out.");
              this.fail(new XalInternalError_1.XalInternalError(XalInternalErrorType_1.XalInternalErrorType.Unknown, "Dtoken operation received bad device identity errors twice in a row."));
              return [2
              /*return*/
              ];
            } else {
              Utils_1.xalTrace(Utils_1.TraceLevel.Important, "Dtoken operation received bad device identity error. Retrying with fresh identity.");
            }

            this.resettingDeviceIdentity = true;
            return [4
            /*yield*/
            , this.tokenStackComponents.xboxCache.resetDeviceIdentity()];

          case 1:
            _a.sent();

            return [4
            /*yield*/
            , this.refreshDtoken()];

          case 2:
            _a.sent();

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return GetDtoken;
}(OperationBase_1.OperationBase);

exports.GetDtoken = GetDtoken;